const ImageContainerStyle = `
display: flex;
flex-wrap: wrap;
justify-content: space-between;
margin-bottom: 16px;
`;

export default ImageContainerStyle;
